import React from 'react';

import {Field} from 'redux-form';
import {View} from 'react-native';
import {BaseField} from '../../../shared/components/baseField';
import {useStyles} from '../../../shared/hooks/styles';
import {Text} from '../../../shared/components/text';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';
import {DeviceSize} from '../../../shared/theme/helpers';
import {ExternalLink} from '../../../shared/components/externalLink';

export const Agreement = () => {
  const content = useSelector(contentSelector());
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginTop: 20,
        marginBottom: 32,
      },
      checkboxContainer: {
        marginRight: 11,
      },
      agreement: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        ...mediaOnly(DeviceSize.desktop, {width: 274}, {width: 229}),
      },
      agreementText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, {...theme.fonts.bodySmallLight, lineHeight: 24}),
        color: theme.color.primaryColor,
      },
      text: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, {...theme.fonts.bodySmallLight, lineHeight: 24}),
      },
    };
  });
  return (
    <View style={styles.container}>
      <View style={styles.checkboxContainer}>
        <Field component={BaseField} type='checkbox' name='agreement' />
      </View>
      <View style={styles.agreement}>
        <Text style={styles.text}>Я принимаю</Text>
        <ExternalLink
          testID='agreeemnet-external-id'
          style={styles.agreementText}
          link={content.docs.agreement}
          text=' соглашение'
          fileName={'eskso_agreement'}
        />
        <Text style={styles.text}>об использовании персональных данных</Text>
      </View>
    </View>
  );
};
